import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../store";
import { ISocialMediaStatus } from "../../../store/repIQSocialMediaStatus/types";
import * as SelectedSocialMediaAction from "../../../store/repIQSelectedSocialMedia/actions";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";

interface IProps {
    disableAction: boolean;
}

const SocialMediaDropDown: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const SelectedNetwork: ISocialMediaStatus = useSelector(
        (state: ApplicationState) => state.repIQSelectedSocialMediaState && state.repIQSelectedSocialMediaState.selectedSocialMedia
    );
    const connectedSocialMediaList: ISocialMediaStatus[] = useSelector(
        (state: ApplicationState) =>
            state.repIQSocialMediaStatusState && state.repIQSocialMediaStatusState.socialMediaStatus && state.repIQSocialMediaStatusState.socialMediaStatus
    );
    const isLoading: boolean = useSelector((state: ApplicationState) => state.repIQSocialMediaStatusState && state.repIQSocialMediaStatusState.isLoading);
    const setSelectedNetwork = (selectedNetwork: ISocialMediaStatus) => dispatch(SelectedSocialMediaAction.actionCreators.setSelectedSocialMedia(selectedNetwork));
    const [lastScan, setLastScan] = useState("");

    const onChange = (e: any) => {
        let val = e.target.value;

        if (val === "") {
            let selectedNetwork: ISocialMediaStatus = getAverage();
            setSelectedNetwork(selectedNetwork);
            setLastScan("");
        } else {
            let selectedNetwork = connectedSocialMediaList.filter((sm: ISocialMediaStatus) => {
                return sm.NetworkID === val;
            });
            setSelectedNetwork(selectedNetwork[0]);
            let sDate = new Date(selectedNetwork[0].LastScanDate);
            setLastScan(sDate.toLocaleString());
        }
    };

    const getAverage = () => {
        let Agreeableness: number = 0;
        let Conscientiousness: number = 0;
        let EmotionalRange: number = 0;
        let Extraversion: number = 0;
        let OpennessToExperiences: number = 0;
        let counter: number = 0;
        let IsPersonalityAnalysing: boolean = true;
        let MinimumWordCountFoundForAIProcess: boolean = false;

        connectedSocialMediaList.forEach((result: ISocialMediaStatus) => {
            if (result.MinimumWordCountFoundForAIProcess === true && result.IsPersonalityAnalysing === false) {
                Agreeableness += result.Agreeableness;
                Conscientiousness += result.Conscientiousness;
                EmotionalRange += result.EmotionalRange;
                Extraversion += result.Extraversion;
                OpennessToExperiences += result.OpennessToExperiences;
                counter++;
            }

            if (result.IsPersonalityAnalysing === false) {
                IsPersonalityAnalysing = false;
            }
            if (result.MinimumWordCountFoundForAIProcess === true) {
                MinimumWordCountFoundForAIProcess = true;
            }
        });
        let response: ISocialMediaStatus = {
            Status: "Connected",
            Username: "",
            NetworkID: 0,
            DisplayOrder: 0,
            NetworkName: "",
            MinimumWordCountFoundForAIProcess: MinimumWordCountFoundForAIProcess,
            IsPersonalityAnalysing: IsPersonalityAnalysing,
            Agreeableness: Agreeableness / counter,
            Conscientiousness: Conscientiousness / counter,
            EmotionalRange: EmotionalRange / counter,
            Extraversion: Extraversion / counter,
            OpennessToExperiences: OpennessToExperiences / counter,
            LastScanDate: "",
        };

        return response;
    };

    useEffect(() => {
        if (SelectedNetwork && SelectedNetwork.NetworkID > 0) {
            let connectedSocialMedia = connectedSocialMediaList.filter((cs: ISocialMediaStatus) => {
                return cs.NetworkID === SelectedNetwork.NetworkID;
            });
            if (connectedSocialMedia && connectedSocialMedia.length > 0) {
                setSelectedNetwork(connectedSocialMedia[0]);
                let sDate = new Date(connectedSocialMedia[0].LastScanDate);
                setLastScan(sDate.toLocaleString());
            } else {
                setSelectedNetwork(getAverage());
                setLastScan("");
            }
        } else {
            setSelectedNetwork(getAverage());
            setLastScan("");
        }
    }, [connectedSocialMediaList]);

    return (
        <React.Fragment>
            {isLoading ? (
                <div className="box loading"></div>
            ) : (
                <div className="row full-width between-xs">
                    <div className="col-xs col-gutter-vertical flex-grow-null">
                        <ul className="list-reset list-inline credit-report-dates">
                            <li className="margin-right-s">
                                {lastScan !== "" && SelectedNetwork.IsPersonalityAnalysing === false && (
                                    <span className="small_text">
                                        <em className="las la-calendar-check icon-inline"></em>
                                        <strong>Last Scan: </strong>
                                        {lastScan && getFormattedDate(i18nService.get("Country"), lastScan)}
                                    </span>
                                )}
                            </li>
                        </ul>
                    </div>
                    <div className="col-xs col-gutter-vertical flex-grow-null">
                        <ul className="list-reset list-inline credit-report-dates">
                            <li className="margin-right-s">
                                <span className="small_text">
                                    <em className="las la-share-alt icon-inline"></em>
                                    <strong>Connected Accounts: </strong>
                                    {connectedSocialMediaList &&
                                        connectedSocialMediaList.map((socialMedia: ISocialMediaStatus, index) => (index ? ", " : "") + socialMedia.NetworkName)}
                                </span>
                            </li>
                            <li>
                                <div className="form-row no-margin">
                                    <div className="form-label sr-only">
                                        <label id="label-connected-accounts">Connected Accounts:</label>
                                    </div>
                                    <div className="form-input">
                                        <select
                                            className="inputbox"
                                            disabled={props.disableAction}
                                            value={SelectedNetwork.NetworkID}
                                            onChange={onChange}
                                            id=""
                                            aria-labelledby="label-connected-accounts"
                                        >
                                            <option value="">View all Accounts</option>
                                            {connectedSocialMediaList &&
                                                connectedSocialMediaList.map((socialMedia: ISocialMediaStatus, index: number) => (
                                                    <option key={index} value={socialMedia.NetworkID}>
                                                        {socialMedia.NetworkName}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};
export default SocialMediaDropDown;
